<template>
  <div>
      <div class="flex">
        <input @change="selectDate($event, true)" type="text" v-model="value" class="form-control">
        <button type="button" class="btn btn-success calendarAction" @click="calendarOpen = !calendarOpen">
          <i class="icon-fa icon-fa-calendar calendarAction"></i>
        </button>
        <date-picker
          :open="calendarOpen"
          v-model="dateValue"
          class="hidden_calc"
          format="MM.YYYY"
          @change="selectDate"
          type="month"
        />
      </div>
  </div>
</template>

<script>

  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';
  import 'vue2-datepicker/locale/ru';
  import moment from 'moment'

  export default {
    components: {
      DatePicker
    },
    props: ['type', 'updateFilter'],
    data() {
      return {
        value: null,
        calendarOpen: false,
        dateValue: null,
      }
    },
    methods: {
      selectDate(e = null, string = false) {
        this.calendarOpen = false;
        if (string === true){
          this.dateValue = new Date(moment(this.value, 'MM.YYYY').toISOString());
        }else {
          this.value = moment(this.dateValue).format('MM.YYYY');
        }
      }
    }
  }

</script>

<style scoped>
  .hidden_calc {
    width: 0px;
    height: 0px;
  }

</style>
<style>
  .hidden_calc .mx-input-wrapper {
    display: none;
  }
</style>
